import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { parse, parseDateWithoutTime, startOfDay } from '@markant-platform/shared/util-helpers';

export class DateValidators {
  private static readonly FORMAT = 'dd.MM.yyyy HH:mm';

  public static interval(startField = 'startDate', endField = 'endDate'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const startDate = control.get(startField);
      const endDate = control.get(endField);

      if (!(startDate?.value && endDate?.value)) {
        return null;
      }

      const start = parse(startDate?.value, DateValidators.FORMAT);
      const end = parse(endDate?.value, DateValidators.FORMAT);

      if (!DateValidators.checkIsDateValid(start) || !DateValidators.checkIsDateValid(end)) {
        return { startDateBeforeEndDate: true };
      }

      return start >= end ? { startDateBeforeEndDate: true } : null;
    };
  }

  public static start(field = 'startDate'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const startDate = control.get(field);

      if (!startDate?.value) {
        return null;
      }

      const now = new Date();
      const nowLocal = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        now.getHours(),
        now.getMinutes(),
        now.getSeconds(),
        now.getMilliseconds()
      );

      const startDateValue = parse(startDate.value, DateValidators.FORMAT);

      return startDateValue.getTime() < nowLocal.getTime() ? { startDateNotInFuture: true } : null;
    };
  }

  public static min({ value }: AbstractControl): ValidationErrors | null {
    if (value && parseDateWithoutTime(value) < startOfDay(new Date())) {
      return { dateIsLessThanToday: true };
    }
    return null;
  }

  private static checkIsDateValid(date: Date): boolean {
    return date.toString() !== 'Invalid Date';
  }
}
